export default Object.freeze({
  API_Admin_Product_Create: 'API_Admin_Product_Create',
  API_Admin_Product_Delete: 'API_Admin_Product_Delete',
  API_Admin_Product_Index: 'API_Admin_Product_Index',

  API_Admin_Resource_Create: 'API_Admin_Resource_Create',
  API_Admin_Resource_Index: 'API_Admin_Resource_Index',

  API_Admin_ProductGroup_Create: 'API_Admin_ProductGroup_Create',
  API_Admin_ProductGroup_Index: 'API_Admin_ProductGroup_Index',

  API_Admin_Booking_Mail_Send: 'API_Admin_Booking_Mail_Send',
  API_Admin_Booking_Payment_Create: 'API_Admin_Booking_Payment_Create',
  API_Admin_Booking_Discount_Update: 'API_Admin_Booking_Discount_Update',
  API_Admin_Booking_Checkin: 'API_Admin_Booking_Checkin',
  API_Admin_Booking_MarkAsChecked: 'API_Admin_Booking_MarkAsChecked',
  API_Admin_Booking_ChangeStatus: 'API_Admin_Booking_ChangeStatus',
  API_Admin_Booking_Visitor_Update: 'API_Admin_Booking_Visitor_Update',
  API_Admin_Booking_Product_Create: 'API_Admin_Booking_Product_Create',
  API_Admin_Booking_Discount_Create: 'API_Admin_Booking_Discount_Create',
  API_Admin_Booking_Voucher_Redeem_Code: 'API_Admin_Booking_Voucher_Redeem_Code',
  API_Admin_Booking_Remark_Create: 'API_Admin_Booking_Remark_Create',
  API_Admin_Booking_Customer_Create: 'API_Admin_Booking_Customer_Create',
  API_Admin_Booking_SetNextBillingMethod: 'API_Admin_Booking_SetNextBillingMethod',

  API_Admin_Payment_Refund: 'API_Admin_Payment_Refund',

  // Temporary, in coleration with Remco the old permission is back until next sprint
  API_Admin_Settings_Read: 'Frontend_Application_Advanced_Settings_View',
  API_Admin_Settings_Write: 'Frontend_Application_Advanced_Settings_View',
})
